import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlighter'
})
export class HighlighterPipe implements PipeTransform {

  transform(value: any, locations: string[]): unknown {
    function uniqueFilter(value: string, index: number, self: string[]) {
      return self.indexOf(value) === index;
    }
    locations = locations.filter(uniqueFilter)
    locations = locations.sort((a, b) => {return b.length - a.length;})


    // for(let location of locations) {
    //   if(location.length <= 1) continue;

    //   if(location.indexOf('.') >= 0) location = location.replace(".", "\\.")
    //   // if(location.charAt(location.length - 1) == '.') location = location.slice(0, location.length - 1) + '\\.'
    //   var locationText = new RegExp(location, 'igm');
    //   value= value.replace(locationText, '<span class="location-highligh">$&</span>');
    // }
    
    /*for(let person of persons) {
      const personText = new RegExp(person, 'igm');
      value= value.replace(personText, '<span class="person-highligh">$&</span>');
    }*/

    return value;
  }

}
